var map = {
	"./default.png": "./admin-thumbs/default.png",
	"./s-accordion.png": "./admin-thumbs/s-accordion.png",
	"./s-block-links.png": "./admin-thumbs/s-block-links.png",
	"./s-block-posts.png": "./admin-thumbs/s-block-posts.png",
	"./s-block-vacancies.png": "./admin-thumbs/s-block-vacancies.png",
	"./s-editor-media.png": "./admin-thumbs/s-editor-media.png",
	"./s-editor.png": "./admin-thumbs/s-editor.png",
	"./s-form.png": "./admin-thumbs/s-form.png",
	"./s-header-image.png": "./admin-thumbs/s-header-image.png",
	"./s-header.png": "./admin-thumbs/s-header.png",
	"./s-list.png": "./admin-thumbs/s-list.png",
	"./s-media.png": "./admin-thumbs/s-media.png",
	"./s-reusable-sections.png": "./admin-thumbs/s-reusable-sections.png",
	"./s-team-selection.png": "./admin-thumbs/s-team-selection.png",
	"./s-team.png": "./admin-thumbs/s-team.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./admin-thumbs sync recursive \\.png$";